import React, { useState, useEffect } from 'react';
import { errorMsg, homeUrl, rearrangeArray, success } from '../utils/common_utils';
import IndefiniteProgressBar from "../ui_components/indefinite_progress_bar";
import { LinkUI } from './common_links';

// https://img.youtube.com/vi/YMAwgRwjEOQ/mqdefault.jpg
// https://img.youtube.com/vi/YMAwgRwjEOQ/0.jpg 
// https://img.youtube.com/vi/YMAwgRwjEOQ/default.jpg
/** pass youtube videoId and title, as of now 
 * titleId is not getting used in ui, it will be used later
 */

function YoutubeVideoDisplay({ videoId, title = '' }) {
  const [isOpen, setIsOpen] = useState(false);

  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
  const youtubeVideoUrl = `https://www.youtube.com/watch?v=${videoId}`;

  const handleOpenModal = () => setIsOpen(true);
  const handleCloseModal = () => setIsOpen(false);

  return (
    <>
      <div className="m-2 w-full max-w-sm rounded-2xl border border-gray-200 bg-white p-3 shadow-sm transition hover:shadow-md">
        <button
          type="button"
          onClick={handleOpenModal}
          className="group relative block w-full overflow-hidden rounded-xl text-left"
          aria-label={title ? `Play ${title}` : 'Play YouTube video'}
        >
          <div className="aspect-video w-full bg-gray-100">
            <img
              src={thumbnailUrl}
              alt={title || 'YouTube Video Thumbnail'}
              className="h-full w-full object-cover transition duration-300 group-hover:scale-[1.02]"
            />
          </div>

          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />

          <div className="absolute inset-0 flex items-center justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/95 shadow-lg transition duration-300 group-hover:scale-105">
              <div className="ml-1 h-0 w-0 border-y-[10px] border-y-transparent border-l-[16px] border-l-red-500" />
            </div>
          </div>

        { false &&
          <div className="absolute left-3 right-3 bottom-3">
            <div className="inline-flex items-center rounded-full bg-black/55 px-2.5 py-1 text-xs font-medium text-white backdrop-blur-sm">
              YouTube Preview
            </div>
          </div>
        }
        </button>

        <div className="mt-3">
          
          { title && 
            <div className="line-clamp-2 min-h-[3rem] text-sm 
          font-semibold leading-6 text-gray-900">
            {title || 'Watch video'}
          </div>
          }

          <div className="mt-3 flex items-center gap-3">
            <button
              type="button"
              onClick={handleOpenModal}
              className="inline-flex items-center gap-2 rounded-full bg-red-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-red-600"
            >
              <span className="inline-block h-0 w-0 border-y-[6px] border-y-transparent border-l-[10px] border-l-white" />
              Watch
            </button>

            <div className="text-sm">
              <LinkUI url={youtubeVideoUrl} text="Open on YouTube" />
            </div>
          </div>
        </div>
      </div>

      {isOpen && <YoutubeVideoModal videoId={videoId} onClose={handleCloseModal} />}
    </>
  );
}

const YoutubeVideoModal = ({ videoId, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
    <div className="relative w-full max-w-4xl rounded-2xl bg-white p-3 shadow-2xl">
      <div className="mb-3 flex items-center justify-between">
        <div className="text-sm font-semibold text-gray-700">Video Preview</div>

        <button
          type="button"
          onClick={onClose}
          className="rounded-full border border-gray-200 px-3 py-1.5 text-sm font-medium text-gray-700 transition hover:bg-gray-100"
        >
          Close
        </button>
      </div>

      <div className="overflow-hidden rounded-xl bg-black">
        <iframe
          className="aspect-video w-full"
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    </div>
  </div>
);

export { YoutubeVideoDisplay, YoutubeVideoModal };